/**
 * Bug #438
 * @Author Anupama P
 * @Date 1 Jul 2021
 */
import { Spinner } from 'react-bootstrap'
import { Wrapper, Text } from './'

export default function Loader({ className = null, message = 'Loading..' }) {
    return (
        <Wrapper className={`text-center ${className}`} style={{ paddingBottom: '10%', fontSize: '16px' }}>
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            <Wrapper>{message}</Wrapper>
        </Wrapper>
    )
}
/** End */